import { Hall } from "../../interfaces";
import { HallFloor } from "../../interfaces";
import { HallRoom } from "../../interfaces";

export enum HallFloorActionTypes {
  FETCH_FLOORS_REQUEST = "@@hall/FETCH_FLOORS_REQUEST",
  FETCH_FLOORS_SUCCESS = "@@hall/FETCH_FLOORS_SUCCESS",
  FETCH_FLOORS_ERROR = "@@hall/FETCH_FLOORS_ERROR",
  FETCH_FLOOR_REQUEST = "@@hall/FETCH_SINGLE_FLOOR_REQUEST",
  FETCH_FLOOR_SUCCESS = "@@hall/FETCH_SINGLE_FLOOR_SUCCESS",
  FETCH_FLOOR_ERROR = "@@hall/FETCH_SINGLE_FLOOR_ERROR",
  CREATE_FLOOR_REQUEST = "@@hall/CREATE_FLOOR_REQUEST",
  CREATE_FLOOR_SUCCESS = "@@hall/CREATE_FLOOR_SUCCESS",
  CREATE_FLOOR_ERROR = "@@hall/CREATE_FLOOR_ERROR",
  UPDATE_FLOOR_REQUEST = "@@hall/UPDATE_FLOOR_REQUEST",
  UPDATE_FLOOR_SUCCESS = "@@hall/UPDATE_FLOOR_SUCCESS",
  UPDATE_FLOOR_ERROR = "@@hall/UPDATE_FLOOR_ERROR",
  DELETE_FLOOR_REQUEST = "@@hall/DELETE_FLOOR_REQUEST",
  DELETE_FLOOR_SUCCESS = "@@hall/DELETE_FLOOR_SUCCESS",
  DELETE_FLOOR_ERROR = "@@hall/DELETE_FLOOR_ERROR",

  FETCH_ROOMS_REQUEST = "@@hall/FETCH_ROOMS_REQUEST",
  FETCH_ROOMS_SUCCESS = "@@hall/FETCH_ROOMS_SUCCESS",
  FETCH_ROOMS_ERROR = "@@hall/FETCH_ROOMS_ERROR",
  FETCH_ROOM_REQUEST = "@@hall/FETCH_SINGLE_ROOM_REQUEST",
  FETCH_ROOM_SUCCESS = "@@hall/FETCH_SINGLE_ROOM_SUCCESS",
  FETCH_ROOM_ERROR = "@@hall/FETCH_SINGLE_ROOM_ERROR",
  CREATE_ROOM_REQUEST = "@@hall/CREATE_ROOM_REQUEST",
  CREATE_ROOM_SUCCESS = "@@hall/CREATE_ROOM_SUCCESS",
  CREATE_ROOM_ERROR = "@@hall/CREATE_ROOM_ERROR",
  UPDATE_ROOM_REQUEST = "@@hall/UPDATE_ROOM_REQUEST",
  UPDATE_ROOM_SUCCESS = "@@hall/UPDATE_ROOM_SUCCESS",
  UPDATE_ROOM_ERROR = "@@hall/UPDATE_ROOM_ERROR",
  DELETE_ROOM_REQUEST = "@@hall/DELETE_ROOM_REQUEST",
  DELETE_ROOM_SUCCESS = "@@hall/DELETE_ROOM_SUCCESS",
  DELETE_ROOM_ERROR = "@@hall/DELETE_ROOM_ERROR",
  CLEAR_FLOOR_STATE = "@@hall/CLEAR_FLOOR_STATE",
}

export type HallFloorState = {
  readonly isHallFloorSubmitting: boolean;
  readonly isHallFloorDeleting: boolean;
  readonly loading: boolean;
  readonly success: boolean;
  readonly failure: boolean;
  readonly error: any;
  readonly deleteSuccess: boolean;
  readonly hall: Hall | null;
  readonly floors: HallFloor[];
  readonly floor: HallFloor | null;
  readonly rooms: HallRoom[];
  readonly room: HallRoom | null;
  readonly page: string;
  readonly isRoomSubmitting: boolean;
  readonly isRoomDeleting: boolean;
};
